import { eventsServiceModule } from '../eventsService/eventsService.module';
import { biService } from './biService';
import { wixApi } from './wixApi';
import { wixBinding } from './wixBinding';

export const wixModule = angular
  .module('bit.wix', [eventsServiceModule.name])
  .factory('biService', biService)
  .factory('wixApi', wixApi)
  .factory('wixBinding', wixBinding);
